// Custom event used on slider change (ie for variant reload)
export const SLIDE_CHANGE = 'slide_change';
export const PRODUCT_STATE_CHANGE = 'product_state_change';
export const ADD_TO_CART = 'add_to_cart';
export const IS_ADDING_TO_CART = 'is_adding_to_cart';
export const VARIANT_SWITCH = 'variant_switch';
// From http://youmightnotneedjquery.com/#delegate
export const on = (selector, eventName, handler) => {
    document.addEventListener(eventName, (e) => {
        // loop parent nodes from the target to the delegation node
        for (let target = e.target; target && target !== this; target = target.parentNode) {
            if (target.matches && target.matches(selector)) {
                handler(target, e);
                break;
            }
        }
    }, false);
};
